export enum LicenseAdditionalEnum {
  SILO = 'SILO',
  SYREN = 'SYREN',
}
